import {
  LabeledPercentageInput,
  LabeledSelectInput,
  LabeledJaarMaandInput,
  LabeledNumberInput
} from "adviesbox-shared";
import { useFormikContext } from "formik";
import React, { ReactElement } from "react";
import { DashboardState } from "../infra/dashboard-types";
import { getNaam } from "../../shared/utils/helpers";
import { DuurOverzichtOptions, ControleGewenstInkomenOptions } from "../../.generated/forms/formstypes";

const gewensteDuurTot = {
  label: "Tot leeftijd",
  value: DuurOverzichtOptions.TotLeeftijd
};

const gewenteDuurBasisOptions = [
  {
    label: "Vaste duur in jaren",
    value: DuurOverzichtOptions.VasteDuurInJaren
  },
  {
    label: "Levenslang",
    value: DuurOverzichtOptions.Levenslang
  }
];

export const ScenarioDoorrekeningOverlijden = (): ReactElement => {
  const { values } = useFormikContext<DashboardState>();

  const gewensteDuurTotLeeftijdTonen =
    values.overlijden.controleNorm.controleGewenstInkomen === ControleGewenstInkomenOptions.Nbi;

  let gewensteDuurOptions = gewenteDuurBasisOptions;
  if (gewensteDuurTotLeeftijdTonen) gewensteDuurOptions = [gewensteDuurTot].concat(gewenteDuurBasisOptions);

  const aanvrager2Tonen = values.aanvrager2 !== null && values.overlijden.scenarioVan.aanvrager1Geselecteerd;
  const aanvrager1Tonen = values.aanvrager2 !== null && values.overlijden.scenarioVan.aanvrager2Geselecteerd;
  const gewensteDuurOverzichtTonen =
    values.overlijden.controleNorm.controleGewenstInkomen === ControleGewenstInkomenOptions.Nbi;

  return (
    <>
      <h3 className="pl-3 pt-3">Doorwerken na overlijden partner</h3>
      <br />
      {aanvrager2Tonen && (
        <>
          <p className="pl-3 pt-3">{getNaam(values.aanvrager2, "Partner")}</p>
          <LabeledPercentageInput
            name="overlijden.orv.partnerPercentage"
            caption="Blijft % werken na overlijden"
            decimalen={0}
          />
        </>
      )}

      {aanvrager1Tonen && (
        <>
          <p className="pl-3 pt-3">{getNaam(values.aanvrager1, "Aanvrager")}</p>
          <LabeledPercentageInput
            name="overlijden.orv.aanvragerPercentage"
            caption="Blijft % werken na overlijden"
            decimalen={0}
          />
        </>
      )}

      {gewensteDuurOverzichtTonen && (
        <>
          <LabeledSelectInput
            name="overlijden.orv.gewensteDuurOverzicht"
            caption="Gewenste duur overzicht"
            options={gewensteDuurOptions}
          />
          {values.overlijden.orv.gewensteDuurOverzicht === DuurOverzichtOptions.TotLeeftijd && (
            <LabeledJaarMaandInput name="overlijden.orv.leeftijd" caption="Leeftijd" />
          )}

          {values.overlijden.orv.gewensteDuurOverzicht === DuurOverzichtOptions.VasteDuurInJaren && (
            <LabeledNumberInput
              name="overlijden.orv.aantalJaar"
              caption="Aantal jaar"
              appendChildren={"Jaar"}
              fieldSize={"s"}
            />
          )}
        </>
      )}
    </>
  );
};
/* istanbul ignore else */ if (process.env.NODE_ENV !== "production")
  ScenarioDoorrekeningOverlijden.displayName = "ScenarioDoorrekening";
